import { type FC, type ReactNode } from 'react';

interface MapPanelProps {
    isActive: boolean;
    children: ReactNode;
}

const MapPanel: FC<MapPanelProps> = ({ isActive, children }) => {
    const mapPanelClass = `map-panel ${isActive ? 'is-active' : ''}`;

    return (
        <div className={mapPanelClass}>
            <div className="map-panel-container">
                {children}
            </div>
        </div>
    );
};

export default MapPanel;
